import { topics } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            大家都在讨论
          </h2>
          <p className="mt-2 text-sm text-foreground-600">热门影视话题一网打尽</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-colors ${colorMap[topic.color]}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}